import { createContext } from 'react';

import { Context } from '../../../types';
import { ServicePaidByOption } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

export default createContext<Context<ServicePaidByOption>>(getContextDefaultValues(api));
